import { render } from "./DataMigrationView.vue?vue&type=template&id=9b0839c6"
import script from "./DataMigrationView.vue?vue&type=script&lang=js"
export * from "./DataMigrationView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__